import { generateEventsFromSchedules } from '../../utils/scheduleHelper';

const asId = (value) => {
  const id = Number(value);
  return Number.isSafeInteger(id) && id > 0
    ? id
    : null;
};
const taskKey = (scheduleId, templateId, startTime) => `${scheduleId}:${templateId}:${startTime}`;

const indexTasks = (tasks) => {
  const matches = new Map();
  tasks.forEach((task) => {
    const scheduleId = asId(task?.scheduleId);
    const templateId = asId(task?.eventTemplateId);
    const startTime = new Date(task?.startDate).getTime();
    if (!scheduleId || !templateId || task.archived || !Number.isFinite(startTime)) return;
    const key = taskKey(scheduleId, templateId, startTime);
    if (!matches.has(key)) matches.set(key, new Set());
    const tagIds = matches.get(key);
    (task.tags || []).forEach((tag) => {
      const id = asId(tag.id);
      if (id) tagIds.add(id);
    });
  });
  return matches;
};

export const getPendingCreatedSchedules = (schedules = [], tasks = [], {
  startDate,
  endDate,
  scheduleExceptions = [],
  barnUsersMap = {},
  barnMetadata = {},
  mappedStatuses = {},
} = {}) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  if (!Number.isFinite(start.getTime()) || !Number.isFinite(end.getTime()) || end < start) return [];
  const now = Date.now();
  const taskMatches = indexTasks(tasks);

  // The caller supplies only locally confirmed creations still awaiting a search result.
  return schedules.filter((schedule) => {
    if (!asId(schedule?.id) || schedule.archived || !schedule.rrule) return false;
    const workflows = (schedule.workflows || []).filter((workflow) => workflow.createEvents !== false);
    if (!workflows.length) return false;
    let occurrences;
    try {
      occurrences = generateEventsFromSchedules([{
        ...schedule,
        metadata: schedule.metadata || {},
        tags: schedule.tags || [],
        workflows,
      }], scheduleExceptions, start, end, barnUsersMap, barnMetadata, mappedStatuses);
    } catch {
      return false;
    }
    return occurrences.some((occurrence) => {
      const occurrenceStart = occurrence.start.getTime();
      const taskStart = occurrenceStart - (Number(schedule.advanceNotice) || 0);
      if (occurrenceStart < start.getTime() || occurrenceStart > end.getTime() || occurrenceStart > now
        || taskStart < start.getTime() || taskStart > end.getTime()) return false;
      const scheduleIds = [asId(schedule.id), asId(occurrence.resource.parentSchedule?.id)].filter(Boolean);
      return workflows.some((workflow) => {
        const templateId = asId(workflow.eventTemplateId) || asId(schedule.eventTemplate?.id);
        if (!templateId) return false;
        const matches = scheduleIds.map((id) => taskMatches.get(taskKey(id, templateId, taskStart))).filter(Boolean);
        const tagIds = (workflow.tagIds || []).map(asId).filter(Boolean);
        if (!tagIds.length) return !matches.length;
        return tagIds.some((tagId) => !matches.some((tags) => tags.has(tagId)));
      });
    });
  });
};

export default getPendingCreatedSchedules;
